@if (searchItemsList?.searchPageData?.orderEntryList?.length) {
  <div class="warrantCount">
    @if (searchItemsList?.searchPageData?.pagination?.totalResults) {
      {{
      ('common.text_account_openPosition_page_totalResultsSinglePag' | cxTranslate).replace(
      '{0}',
      searchItemsList?.searchPageData?.pagination?.totalResults
      )
      }}
    }
    @if (!searchItemsList?.searchPageData?.pagination?.totalResults) {
      {{ 'common.text_account_openPosition_emptyPositions' | cxTranslate }}
    }
  </div>
}
@if (searchItemsList?.searchPageData?.orderEntryList?.length > 0) {
  <div class="WarrantyTableOuter">
    <table class="table table-bordered table-blue order-status-table warrantySearchTable openPositionTable">
      <thead>
        <tr>
          <th scope="col" class="warranty-search-refNo">
            <span class="a-underline"
              (click)="sort(searchItemsList?.searchPageData?.pagination.sort === 'byCategoryDesc' ? 'byCategory' : 'byCategoryDesc')">
              <u>{{ 'common.open_order_category' | cxTranslate }}</u>
              <span class="ml-1">
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byCategory') {
                  &#8593;
                }
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byCategoryDesc') {
                  &#8595;
                }
              </span>
            </span>
          </th>
          <th scope="col DateTh" class="orderDate">
            <span class="a-underline"
              (click)="sort(searchItemsList?.searchPageData?.pagination.sort === 'byDateDesc' ? 'byDate' : 'byDateDesc')">
              <u>{{ 'common.text_account_table_header_date' | cxTranslate }}</u>
              <span>
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byDate') {
                  &#8593;
                }
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byDateDesc') {
                  &#8595;
                }
              </span>
            </span>
          </th>
          <th scope="col DateTh">
            <span class="a-underline"
              (click)="sort(searchItemsList?.searchPageData?.pagination.sort === 'byCodeDesc' ? 'byCode' : 'byCodeDesc')">
              <u>{{ 'common.text_account_table_header_order' | cxTranslate }}</u>
              <span class="ml-1">
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byCode') {
                  &#8593;
                }
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byCodeDesc') {
                  &#8595;
                }
              </span>
            </span>
          </th>
          <th scope="col DateTh">
            <span class="a-underline"
              (click)="sort(searchItemsList?.searchPageData?.pagination.sort === 'byPODesc' ? 'byPO' : 'byPODesc')">
              <u> {{ 'common.text_account_table_header_poNumber' | cxTranslate }}</u>
              <span class="ml-1">
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byPO') {
                  &#8593;
                }
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byPODesc') {
                  &#8595;
                }
              </span>
            </span>
          </th>
          <th scope="col DateTh">
            <span class="a-underline"
              (click)="sort(searchItemsList?.searchPageData?.pagination.sort === 'byPartNoDesc' ? 'byPartNo' : 'byPartNoDesc')">
              <u> {{ 'common.text_quickOrder_page_part_no' | cxTranslate }}</u>
              <span class="ml-1">
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byPartNo') {
                  &#8593;
                }
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byPartNoDesc') {
                  &#8595;
                }
              </span>
            </span>
          </th>
          <th scope="col" class="warranty-search-refNo">
            <span class="a-underline"
              (click)="sort(searchItemsList?.searchPageData?.pagination.sort === 'byTypeNoDesc' ? 'byTypeNo' : 'byTypeNoDesc')">
              <u>{{ 'common.open_type_number' | cxTranslate }}</u>
              <span class="ml-1">
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byTypeNo') {
                  &#8593;
                }
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byTypeNoDesc') {
                  &#8595;
                }
              </span>
            </span>
          </th>
          <th scope="col" class="warranty-search-refNo">
            <span class="a-underline"
              (click)="sort(searchItemsList?.searchPageData?.pagination.sort === 'byDescriptionDesc' ? 'byDescription' : 'byDescriptionDesc')">
              <u>{{ 'common.text_description' | cxTranslate }}</u>
              <span class="ml-1">
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byDescription') {
                  &#8593;
                }
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byDescriptionDesc') {
                  &#8595;
                }
              </span>
            </span>
          </th>
          <th scope="col" class="warranty-search-refNo">
            <span class="a-underline"
              (click)="sort(searchItemsList?.searchPageData?.pagination.sort === 'byOpenQtyDesc' ? 'byOpenQty' : 'byOpenQtyDesc')">
              <u>{{ 'common.open_qty' | cxTranslate }}</u>
              <span class="ml-1">
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byOpenQty') {
                  &#8593;
                }
                @if (searchItemsList?.searchPageData?.pagination.sort === 'byOpenQtyDesc') {
                  &#8595;
                }
              </span>
            </span>
          </th>
          @if (fleetPrideGroup && showNetPrice$|async) {
            <th scope="col">
              <span class="a-underline"
                (click)="sort(searchItemsList?.searchPageData?.pagination.sort === 'byOpenTotalDesc' ? 'byOpenTotal' : 'byOpenTotalDesc')">
                <u>
                  {{
                  ('common.open_total_usd_NA' | cxTranslate).replace('{0}',
                  searchItemsList?.searchPageData?.orderEntryList[0].basePrice.currencyIso)
                  }}
                </u>
                <span class="ml-1">
                  @if (searchItemsList?.searchPageData?.pagination.sort === 'byOpenTotal') {
                    &#8593;
                  }
                  @if (searchItemsList?.searchPageData?.pagination.sort === 'byOpenTotalDesc') {
                    &#8595;
                  }
                </span>
              </span>
            </th>
          }
          <th class="estimateDeliveryDate" scope="col">
            <span class="a-underline no-underline">
              {{ 'common.open_estimated_delivery_date' | cxTranslate }}
            </span>
          </th>
        </tr>
      </thead>
      @if (searchItemsList?.searchPageData?.orderEntryList) {
        <tbody>
          @for (item of searchItemsList?.searchPageData?.orderEntryList; track item) {
            <tr class="responsive-table-item">
              <td class="responsive-table-cell">
                <span class="d-lg-none">{{ 'common.open_order_category' | cxTranslate }}</span>
                <span>{{ item?.orderCategory?.name }}</span>
              </td>
              <td class="responsive-table-cell DateTh orderDate">
                <span class="d-lg-none">{{ 'common.text_account_table_header_date' | cxTranslate }}</span>
                <span>{{ item?.placedBaserStoreFormat }}</span>
              </td>
              <td class="responsive-table-cell">
                <span class="d-lg-none">{{ 'common.text_account_table_header_order' | cxTranslate }}</span>
                <span class="text-blue" (click)="redirectOrder(item)">
                  {{ item?.orderCode }}
                </span>
              </td>
              <td class="responsive-table-cell">
                <span class="d-lg-none">{{ 'common.text_account_table_header_poNumber' | cxTranslate }}</span>
                <span class="text-blue" (click)="redirectOrder(item)">
                  {{ item.purchaseOrderNumber }}
                </span>
              </td>
              <td class="responsive-table-cell">
                <span class="d-lg-none">{{ 'common.text_quickOrder_page_part_no' | cxTranslate }}</span>
                <span>{{ item.product?.code }}</span>
              </td>
              <td class="responsive-table-cell">
                <span>{{ 'common.open_type_number' | cxTranslate }}</span>
                <span>{{ item.product.typenumber }}</span>
              </td>
              <td class="responsive-table-cell">
                <span class="d-lg-none">{{ 'common.text_description' | cxTranslate }}</span>
                <span>{{ item.product.description }}</span>
              </td>
              <td class="responsive-table-cell">
                <span class="d-lg-none">{{ 'common.open_qty' | cxTranslate }}</span>
                <span>{{ item.openQty }}</span>
              </td>
              @if (fleetPrideGroup && showNetPrice$|async) {
                <td class="responsive-table-cell">
                  <span class="d-lg-none">{{('common.open_total_usd_NA' | cxTranslate).replace('{0}',
                  searchItemsList?.searchPageData?.orderEntryList[0].basePrice.currencyIso)}}</span>
                  <span>{{ item.netPricePerPiece?.formattedValue }}</span>
                </td>
              }
              <td class="responsive-table-cell estimateDeliveryDate">
                <span class="d-lg-none">{{ 'common.open_estimated_delivery_date' | cxTranslate }}</span>
                <span>{{ (item.scheduleLines?.[0]?.estimatedDate | date: dateFormat) || '' }}</span>
              </td>
            </tr>
          }
        </tbody>
      }
    </table>
    <div class="orderhistory">
      <p> {{'common.order_history_openposition_price_label' | cxTranslate}}</p>
    </div>
    <div class="exportDownloadButton">
      <div class="fs_20">{{ 'common.click_export_download' | cxTranslate }}</div>
      <div class="fs_24 exportDownloadbtnBlock">
        <button (click)="exportToExcelFile()" class="btn btn-primary export-btn">
          {{ 'common.text_account_openPositions_export' | cxTranslate }}
          <img class="hover-img" src="/icons/link-grey.svg" width="20px" alt="" />
        </button>
      </div>
    </div>
    <!-- Pagination -->
    @if (searchItemsList?.searchPageData?.orderEntryList) {
      <div class="product__list--wrapper">
        <div class="pagination-bar bottom">
          <div class="pagination-toolbar">
            <div class="row sort-refine-bar">
              <div class="col-xs-12 col-sm-12 col-md-6 bottom-result">
                <div class="pagination-result">
                  <label class="col-md-12 pl-0">{{'common.search_page_showing_text'|cxTranslate}}
                    {{( searchItemsList?.searchPageData.pagination.pageSize *
                    searchItemsList?.searchPageData.pagination.currentPage)+1 }}-
                    @if ( searchItemsList?.searchPageData.pagination.pageSize *( searchItemsList?.searchPageData.pagination.currentPage+1) <
                      searchItemsList?.searchPageData.pagination.totalResults) {
                      <span>{{
                        searchItemsList?.searchPageData.pagination.pageSize
                      *( searchItemsList?.searchPageData.pagination.currentPage+1)}}</span>
                    }
                    @if ( searchItemsList?.searchPageData.pagination.pageSize *( searchItemsList?.searchPageData.pagination.currentPage+1) >
                      searchItemsList?.searchPageData.pagination.totalResults) {
                      <span>{{
                      searchItemsList?.searchPageData.pagination.totalResults}}</span>
                    }
                    {{'common.search_page_of_text'|cxTranslate}} {{
                    searchItemsList?.searchPageData.pagination.totalResults}}
                  {{'common.search_page_result_text'|cxTranslate}}</label>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 kb-pagination-right kb-pagination">
                <kb-pagination [pagination]="searchItemsList?.searchPageData?.pagination" [defaultPage]="0"
                  (viewPageEvent)="postOpenPositionData($event)">
                </kb-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="myProfileBody no-result-found">
    <div class="warranty-noresult">
      <p>{{ 'common.text_account_openPosition_emptyPositions' | cxTranslate }}</p>
    </div>
  </div>
}

